import axios from "axios";

export const axiosInstance = axios.create({ baseURL: "https://www.arca.am/backend" });
// export const axiosInstance = axios.create({baseURL: "http://192.168.1.185:5001"});
